import { Button, FormHelperText } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import { verifyUser } from "../authSlice"
import ChangeNumberAndSendAgainButtons from "./ChangeNumberAndSendAgainButtons"
import CodeInput, { CodeInputRef } from "./CodeInput"
import CodeTimer from "./CodeTimer"

const StyledContainer = styled.div`
  text-align: center;
`
const StyledError = styled(FormHelperText).attrs({ error: true })`
  text-align: center !important;
  margin-top: 8px;
`

const StyledCodeTimer = styled(CodeTimer)`
  margin-top: 14px;
`

const StyledSubmitButton = styled(Button)<{ $disabled: boolean }>`
  width: 100%;
  height: 45px;
  background: ${(p) => (p.$disabled ? "#999999" : "black")};
  color: ${(p) => (p.$disabled ? "#101010" : "white")} !important;
  margin-top: 20px;
  border: ${(p) => p.$disabled && "none"};
  :hover {
    background: ${(p) => p.theme.colors.steel};
  }

  &:active,
  :focus {
    background: black;
    color: white;
    border: none;
    outline: none;
  }
`

export const errorId = "otp-error"

const OTPForm = () => {
  const { error, loading } = useTypedSelector((state) => state.auth)
  const [isDisabled, setIsDisabled] = useState(true)

  const dispatch = useAppDispatch()

  const codeInputRef = useRef<CodeInputRef>(null)

  // Reset the code when there's an error
  useEffect(() => {
    if (error) {
      codeInputRef.current?.reset(), setIsDisabled(true)
    }
  }, [error])

  return (
    <StyledContainer>
      <CodeInput
        length={4}
        onComplete={async (code: string) => {
          setIsDisabled(false)
          await dispatch(verifyUser(code))
        }}
        ref={codeInputRef}
        disabled={loading}
      />
      <StyledError role="alert" id={errorId}>
        {error}
      </StyledError>

      <StyledCodeTimer />
      <ChangeNumberAndSendAgainButtons
        focusCodeInput={() => codeInputRef.current?.focus?.()}
      />
      <StyledSubmitButton
        // onClick={() =>
        //   code.length === 0 && setEmptyError("אנא הזן את הקוד שנשלח")
        // }
        $disabled={isDisabled}
        disabled={isDisabled}
      >
        המשך
      </StyledSubmitButton>
    </StyledContainer>
  )
}

export default OTPForm
